import React from "react";
import ComplianceDocument from "../components/ui/ComplianceDocument";

export default function TermsPage(): React.JSX.Element {
  return (
    <ComplianceDocument
      slug="terms-of-service"
      title="Terms of Service"
      description={
        <span>
          These Terms govern your use of <strong>kivo.skin</strong> (the “Service”). They include important
          information about your rights. Nothing here is medical advice. By using the Service,
          you agree to these Terms.
        </span>
      }
    />
  );
}
